import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, AuthService, MessageService } from '../../../core';

import { Subscription } from 'rxjs';
import { TabelaPrecoFilterSearch } from '../filter';
import { TabelaPrecoCrudHttpService } from '../services';
import { TabelaPreco } from '../tabela-preco';
import { isTabelaPrecoSituacaoInativa, tabelaPrecoAtiva } from '../tabela-preco-situacao';

@Component({
    selector: 'sgt-tabela-preco-select',
    templateUrl: './tabela-preco-select.component.html',
    styleUrls: ['./tabela-preco-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TabelaPrecoSelectComponent), multi: true },
    ]
})
export class TabelaPrecoSelectComponent implements OnInit {
    /** ID da tabela de preço */
    @Input() ngModel: number;
    /** Ao alterar a tabale de preço */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tabela de Preço */
    @Input() tabelaPreco: TabelaPreco;
    @Output() tabelaPrecoChange = new EventEmitter<TabelaPreco>();

    /** Tabelas de preços */
    tabelasPrecos: TabelaPreco[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se deve pesquisar as tabelas de preços ao iniciar o component */
    @Input() searchOnInit = true;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUMA TABELA DE PREÇO'
    /** Se deve filtrar somente as tabelas de preços ativas */
    @Input() somenteAtivas = false;
    /** Se deve filtrar somente as tabelas de preços disponíveis para o representante logado */
    @Input() somenteTabelasPrecosRepresentante = true;

    @ViewChild('select') select: ElementRef;

    private tabelasPrecosSearchSub$ = new Subscription();
    propagateChange: any = () => {};

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private tabelaPrecoCrudHttpService: TabelaPrecoCrudHttpService) { }

    ngOnInit() {
        if (this.searchOnInit) {
            this.search();
        }
    }


    /** Pesquisa as tabelas de preços */
    search(): Promise<TabelaPreco[]> {
        return new Promise<TabelaPreco[]>((resolve, reject) => {
            this.tabelasPrecos = [];

            // Filter
            const filter = new TabelaPrecoFilterSearch();
            // Somente ativas
            if (this.somenteAtivas) {
                filter.situacao = tabelaPrecoAtiva.id;
            }
            // Somente as tabelas de preços disponíveis para o representante
            if (this.authService.isRepresentante() && this.somenteTabelasPrecosRepresentante) {
                filter.idRepresentante = this.authService.getIdRepresentante();
            }

            this.tabelasPrecosSearchSub$?.unsubscribe();
            this.tabelasPrecosSearchSub$ = this.tabelaPrecoCrudHttpService.searchWithFilter(filter,  null, null, null, 2, 'asc')
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => {
                        this.tabelasPrecos = response.data;

                        if (this.tabelaPreco) {
                            const indexTabelaPreco = this.tabelasPrecos?.findIndex(tabelaPrecoFilter => tabelaPrecoFilter.id === this.tabelaPreco.id);
                            if (indexTabelaPreco < 0) {
                                this.tabelasPrecos.unshift(this.tabelaPreco);
                            }
                        }

                        resolve(this.tabelasPrecos);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as tabelas de preços', error);
                        reject(error);
                    }
                );
        });
    }

    /** Verifica se a tabela de preço está inativa */
    isSituacaoInativa(situacao: number): boolean {
        return isTabelaPrecoSituacaoInativa(situacao);
    }

    /** Ao alterar a tabela de preço */
    onChange(idTabelaPreco: number) {
        this.ngModel = idTabelaPreco;
        this.propagateChange(this.ngModel);

        this.tabelaPreco = this.tabelasPrecos?.find(tabelaPrecoFilter => tabelaPrecoFilter.id === idTabelaPreco);
        this.tabelaPrecoChange.emit(this.tabelaPreco);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
